import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["field", "status"]
  static values = { statusSelector: String }

  connect() {
    console.log('Autosave controller connected')
    this.timeout = null
    this.saveDelay = 1000 // 1 second delay
  }

  get statusElement() {
    if (this.hasStatusSelectorValue) {
      return document.querySelector(this.statusSelectorValue)
    }
    return this.hasStatusTarget ? this.statusTarget : null
  }

  fieldChanged() {
    console.log('Field changed, scheduling save...')
    // Clear existing timeout
    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    // Show pending status
    const status = this.statusElement
    if (status) {
      status.textContent = "Saving..."
      status.classList.remove("text-green-600", "text-red-600")
      status.classList.add("text-gray-500")
    }

    // Set new timeout
    this.timeout = setTimeout(() => {
      this.save()
    }, this.saveDelay)
  }

  save() {
    const form = this.element
    const formData = new FormData(form)

    console.log('Autosaving to:', form.action)

    fetch(form.action, {
      method: 'PATCH',
      body: formData,
      headers: {
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
        'Accept': 'application/json'
      }
    })
    .then(response => {
      if (!response.ok) throw new Error('Network response was not ok')
      return response.json()
    })
    .then(data => {
      const status = this.statusElement
      if (status) {
        status.textContent = "Saved"
        status.classList.remove("text-gray-500", "text-red-600")
        status.classList.add("text-green-600")

        // Clear status after 2 seconds
        setTimeout(() => {
          status.textContent = ""
        }, 2000)
      }

      // Show unpublished banner if it exists
      const unpublishedBanner = document.getElementById('unpublished-banner')
      if (unpublishedBanner) {
        unpublishedBanner.classList.remove('hidden')
      }

      // Dispatch event with response data so nested forms can sync IDs
      this.dispatch("saved", { detail: data })
    })
    .catch(error => {
      console.error('Save failed:', error)
      const status = this.statusElement
      if (status) {
        status.textContent = "Save failed"
        status.classList.remove("text-gray-500", "text-green-600")
        status.classList.add("text-red-600")
      }
    })
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }
}